module.exports = __webpack_public_path__ + "img/9788997381142.3c6fea29.jpg";